import { useState, useEffect, useRef } from "react";
import { Search, X } from "lucide-react";

interface LicitacionSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function LicitacionSearch({ value, onChange, placeholder = "Buscar por t\u00edtulo, referencia u organismo..." }: LicitacionSearchProps) {
  const [internal, setInternal] = useState(value);
  const isFirst = useRef(true);

  useEffect(() => { setInternal(value); }, [value]);

  useEffect(() => {
    if (isFirst.current) { isFirst.current = false; return; }
    const timer = setTimeout(() => onChange(internal), 300);
    return () => clearTimeout(timer);
  }, [internal, onChange]);

  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
      <input
        type="text"
        value={internal}
        onChange={(e) => setInternal(e.target.value)}
        placeholder={placeholder}
        className="w-full px-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
      />
      {internal && (
        <button onClick={() => { setInternal(""); onChange(""); }} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
